var _path, _path2, _path3, _path4, _circle, _circle2, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllergy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 276 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 51V225C7 249.301 26.6995 269 51 269H225C249.301 269 269 249.301 269 225V51C269 26.6995 249.301 7 225 7H51C26.6995 7 7 26.6995 7 51Z",
    stroke: "#8E8E8E",
    strokeWidth: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.007 169.5V123.5C87.5029 124.802 96.1696 123.972 111.507 115.5C117.507 112.186 121.552 106.4 139.007 101C151.192 103.356 152.507 105 169.507 115.5C177.459 122.173 184.915 124.45 208.507 123.5V166C209.612 179.784 204.82 182.512 191.507 183H90.007C76.2782 184.158 71.797 181.724 72.007 169.5Z",
    stroke: "#8E8E8E",
    strokeWidth: 14
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202 135C198.022 135 194.206 136.58 191.393 139.393C188.58 142.206 187 146.022 187 150C187 153.978 188.58 157.794 191.393 160.607C194.206 163.42 198.022 165 202 165L202 150L202 135Z",
    fill: "#8E8E8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 135C81.9782 135 85.7936 136.58 88.6066 139.393C91.4196 142.206 93 146.022 93 150C93 153.978 91.4196 157.794 88.6066 160.607C85.7936 163.42 81.9782 165 78 165L78 150L78 135Z",
    fill: "#8E8E8E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118.5,
    cy: 143.5,
    r: 8.5,
    fill: "#8E8E8E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 156.5,
    r: 8.5,
    fill: "#8E8E8E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 82.9111,
    width: 13,
    height: 18,
    rx: 6,
    transform: "rotate(-43.2706 101 82.9111)",
    fill: "#8E8E8E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 133.491,
    y: 67,
    width: 13,
    height: 18,
    rx: 6,
    transform: "rotate(1.56293 133.491 67)",
    fill: "#8E8E8E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 169.671,
    y: 74,
    width: 13,
    height: 18,
    rx: 6,
    transform: "rotate(54.5939 169.671 74)",
    fill: "#8E8E8E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergy);
export default __webpack_public_path__ + "static/media/allergy.af16561dee9d2be015dc33d793a5e68d.svg";
export { ForwardRef as ReactComponent };